// Procedural name generator: adjective_noun_N
const ADJECTIVES = [
  'quiet', 'bold', 'silent', 'crimson', 'azure', 'pale', 'fierce',
  'gentle', 'hollow', 'lucid', 'molten', 'patient', 'restless',
  'serene', 'tender', 'velvet', 'wired', 'amber', 'frozen',
  'humble', 'lonely', 'midnight', 'noble', 'opal', 'quick',
  'ragged', 'subtle', 'tangled', 'urban', 'vacant', 'wandering',
  'electric', 'kinetic', 'sovereign', 'tactical', 'cryptic',
];

const NOUNS = [
  'glider', 'kestrel', 'jakarta', 'pulsar', 'oracle', 'cipher',
  'beacon', 'falcon', 'echo', 'phoenix', 'ember', 'rune',
  'sentinel', 'orbit', 'lattice', 'mantis', 'sable', 'tundra',
  'volt', 'wisp', 'zenith', 'aether', 'binary', 'compass',
  'drift', 'fjord', 'glow', 'hex', 'index', 'jolt',
  'koan', 'lumen', 'monad', 'node', 'omega',
];

export function generateName(rand: () => number): string {
  const adj = ADJECTIVES[Math.floor(rand() * ADJECTIVES.length)];
  const noun = NOUNS[Math.floor(rand() * NOUNS.length)];
  const num = Math.floor(rand() * 99);
  return `${adj}_${noun}_${num}`;
}

export function mockTonAddress(rand: () => number): string {
  // EQ + 46 base64-ish chars
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
  let out = 'EQ';
  for (let i = 0; i < 46; i++) {
    out += chars[Math.floor(rand() * chars.length)];
  }
  return out;
}
